"use client";

import Link from "next/link";
import { MdPublic, MdSchool, MdQuestionMark, MdArticle } from "react-icons/md";
import { HiArrowRight } from "react-icons/hi";

const resources = [
  {
    title: "Country Explorer",
    description:
      "Compare study destinations across 18+ countries. Explore costs, visa processes, university options, and student life insights — all in one interactive map.",
    href: "/country-explorer",
    icon: MdPublic,
    iconColor: "text-[#3b82f6]",
    iconBg: "bg-[#3b82f6]/10",
    hoverBorder: "hover:border-[#3b82f6]/40",
  },
  {
    title: "Scholarship Hub",
    description:
      "Discover 100+ scholarships across 15 countries — from fully-funded government programs to university grants. Find funding that fits your profile.",
    href: "/scholarships",
    icon: MdSchool,
    iconColor: "text-[#8b5cf6]",
    iconBg: "bg-[#8b5cf6]/10",
    hoverBorder: "hover:border-[#8b5cf6]/40",
  },
  {
    title: "FAQ",
    description:
      "Get answers to the most common questions about studying abroad with Lattu AI — how it works, countries covered, scholarships, visa guidance, and more.",
    href: "/FAQ",
    icon: MdQuestionMark,
    iconColor: "text-[#ec4899]",
    iconBg: "bg-[#ec4899]/10",
    hoverBorder: "hover:border-[#ec4899]/40",
  },
  {
    title: "Blog",
    description:
      "Read expert articles, student stories, and guides written by mentors and education specialists — covering visa tips, country insights, scholarship strategies, and more.",
    href: "/blog",
    icon: MdArticle,
    iconColor: "text-[#f59e0b]",
    iconBg: "bg-[#f59e0b]/10",
    hoverBorder: "hover:border-[#f59e0b]/40",
  },
];

export default function ResourcesContent() {
  return (
    <main className="overflow-hidden">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-transparent">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl lg:text-5xl font-black text-black dark:text-white tracking-tight leading-tight">
            Resource Center
          </h1>
          <p className="mt-4 text-lg text-zinc-600 dark:text-zinc-400 max-w-2xl mx-auto leading-relaxed">
            Everything you need to plan, prepare, and succeed in your
            study-abroad journey — all in one place.
          </p>
        </div>
      </section>

      {/* Resource Cards */}
      <section className="pb-24 bg-transparent">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {resources.map((resource) => (
              <Link
                key={resource.title}
                href={resource.href}
                className={`group p-8 bg-[#eceff1] dark:bg-[#1a1a1a]/40 backdrop-blur-sm rounded-xl border border-black/5 dark:border-white/10 ${resource.hoverBorder} transition-all duration-300 hover:-translate-y-1 hover:shadow-lg dark:hover:shadow-black/20 block`}
              >
                <div
                  className={`w-14 h-14 ${resource.iconBg} rounded-xl flex items-center justify-center mb-6 ${resource.iconColor} group-hover:scale-110 transition-transform duration-300`}
                >
                  <resource.icon size={28} />
                </div>
                <h2 className="text-xl font-black text-black dark:text-white mb-3">
                  {resource.title}
                </h2>
                <p className="text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed mb-6">
                  {resource.description}
                </p>
                <div
                  className={`flex items-center gap-2 text-sm font-bold ${resource.iconColor} group-hover:gap-3 transition-all duration-300`}
                >
                  Visit
                  <HiArrowRight className="w-4 h-4" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
